import React from "react";
import './SparePartsTable.scss'

interface ISparePartsTableProps {
  data: App.IObject
}

export default class SparePartsTable extends React.Component<ISparePartsTableProps, any> {

  render() {
    return <div className='spare-parts-table'>
      <div className='spare-parts-table-head'>
        <div className='row'>
          <div>Запасные части для ТО</div>
          <div>Кол-во</div>
        </div>
      </div>
      <div className='spare-parts-table-content'>
        {
          Object.keys(this.props.data).map((key) => {
            if (this.props.data.hasOwnProperty(key)) {
              return <div key={key} className='row'>
                <div>{this.props.data[key].name}</div>
                <div>{this.props.data[key].vol}</div>
              </div>
            } else
              return <></>
          })
        }
      </div>
    </div>
  }
}